<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo">
          <img style="width: 100px;" src="../../assets/images/logo/LogoVls.png">
          <h2 class="brand-text text-primary ml-1" />
        </b-link>

        <!-- Sucesso -->
        <template v-if="sent">
          <div class="text-center py-2">
            <div class="mb-2" style="font-size:48px">📧</div>
            <b-card-title class="mb-1">E-mail enviado!</b-card-title>
            <b-card-text class="mb-2">
              Enviamos um link de redefinição para <strong>{{ userEmail }}</strong>.<br>
              Verifique sua caixa de entrada (e a pasta de spam).
            </b-card-text>
            <b-card-text class="mb-2" style="font-size:12px;color:#94a3b8">
              O link expira em 1 hora.
            </b-card-text>
            <b-button variant="outline-primary" block :to="{ name: 'auth-login' }">
              Voltar ao login
            </b-button>
            <b-card-text class="text-center mt-2">
              <span>Não recebeu? </span>
              <b-link @click="sent = false">Reenviar</b-link>
            </b-card-text>
          </div>
        </template>

        <!-- Formulário -->
        <template v-else>
          <b-card-title class="mb-1">
            Recuperar Senha 🔒
          </b-card-title>
          <b-card-text class="mb-2">
            Digite seu e-mail e enviaremos um link para criar uma nova senha.
          </b-card-text>

          <b-alert v-if="errorMsg" variant="danger" show class="mb-1">
            <small>{{ errorMsg }}</small>
          </b-alert>

          <validation-observer ref="simpleRules">
            <b-form class="auth-forgot-password-form mt-2" @submit.prevent="validationForm">
              <b-form-group label="E-mail" label-for="forgot-password-email">
                <validation-provider #default="{ errors }" name="Email" rules="required|email">
                  <b-form-input
                    id="forgot-password-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="forgot-password-email"
                    placeholder="seu@email.com"
                    :disabled="loading"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <b-button variant="primary" block type="submit" :disabled="loading">
                <b-spinner v-if="loading" small class="mr-1" />
                {{ loading ? 'Enviando...' : 'Enviar link de redefinição' }}
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <b-link :to="{ name: 'auth-login' }">
              <feather-icon icon="ChevronLeftIcon" /> Voltar ao login
            </b-link>
          </b-card-text>
        </template>
      </b-card>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BCard, BLink, BCardText, BCardTitle, BFormGroup, BFormInput, BForm, BButton, BAlert, BSpinner,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import PassWordService from '@/services/RedefirSenha'

export default {
  components: {
    BCard, BLink, BCardText, BCardTitle, BFormGroup, BFormInput, BButton, BForm, BAlert, BSpinner,
    ValidationProvider, ValidationObserver,
  },
  data() {
    return {
      userEmail: '',
      loading: false,
      sent: false,
      errorMsg: '',
      required,
      email,
    }
  },
  methods: {
    async validationForm() {
      const valid = await this.$refs.simpleRules.validate()
      if (!valid) return
      this.loading = true
      this.errorMsg = ''
      try {
        await PassWordService.ChangePassword(this.userEmail)
        this.sent = true
      } catch (error) {
        this.errorMsg = 'Não foi possível enviar o e-mail. Tente novamente em instantes.'
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
